/* eslint-disable max-len */
import Router from 'next/router';

import isEmpty from 'lodash/isEmpty';
import qs from 'query-string';

import { removeAllCookies } from '../redux/utils/cookiesUser';

const ERROR_MSG = 'Tivemos problema com sua solicitação, tente novamente.';
const TIMEOU_ERROR_MSG = 'Tempo máximo excedido para essa solicitação, tente novamente.';

const isProduction = false; // process.env.NODE_ENV === 'production';

const oceanAPI = process.env.NEXT_PUBLIC_OCEAN;
const servicesAPI = process.env.NEXT_PUBLIC_SERVICES;

const formatter = new Intl.DateTimeFormat('pt-BR', {
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  fractionalSecondDigits: 3,
});

const getUrl = (type) => {
  switch (type) {
    case '':
      return servicesAPI;
    case 'ocean':
      return `${oceanAPI}ocean-api/`;
    default:
      return type;
  }
};

const createHeaders = (token, method = 'GET', overrideHeaders = {}) => {
  const headers = {};

  if (token) {
    headers.headers = { Authorization: `Bearer ${token}` };
  }

  if (method && method !== 'GET' && method !== 'DELETE') {
    headers.headers = { ...(headers.headers || {}), 'Content-Type': 'application/json' };
  }

  headers.headers = { ...headers.headers, ...overrideHeaders };

  return headers;
};

const getResponseData = (type, response) => {
  if (response.status === 401 && typeof window !== 'undefined' && !response.url.includes('account')) {
    removeAllCookies(window.location.host.replace(/^\w+/m, ''));

    if (window.location.pathname.includes('carrinho') || window.location.pathname.includes('minhaconta')) {
      window.location.assign(`/cliente/login?next=${window.location.pathname}&section=false`);
    } else {
      Router.push(window.location.pathname);
    }
  }

  if (response.status === 204) {
    return {};
  }

  if (response && type.includes('pdf')) {
    return response.blob();
  }

  if (response && type.includes('xml')) {
    return response.text();
  }

  if (response && type.includes('json')) {
    return response.json();
  }

  return {};
};

const fetchTimeout = async (promise, throwError, TIMEOUT_FETCH) => {
  const timeout = new Promise((resolve, reject) =>
    setTimeout(() => {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject({ ok: false, message: TIMEOU_ERROR_MSG });
    }, TIMEOUT_FETCH)
  );

  return Promise.race([timeout, promise]);
};

const requestAPI = (url, baseAPI = '') => {
  const options = { method: 'GET' };
  const isServer = typeof window !== 'undefined';

  let startTme = '';

  if (!isProduction) {
    startTme = new Date();
  }

  async function executeRequest(
    queryParams,
    overrideOptions = {},
    throwError,
    timeout = process.env.NEXT_PUBLIC_TIMEOUT_FETCH
  ) {
    const headers = { ...options, ...overrideOptions };
    try {
      const finalUrl = `${getUrl(baseAPI)}${url}${!isEmpty(queryParams) ? `?${qs.stringify(queryParams)}` : ''}`;
      const response = await fetchTimeout(fetch(new URL(finalUrl), headers), throwError, timeout);

      const data = await getResponseData(
        response.headers.get('content-type') || '',
        response,
        headers.headers ? headers.headers.Token || headers.headers.token : null
      );

      if (!isProduction) {
        const time = new Date().getTime() - startTme.getTime();
        console.log(`${formatter.format(Date.now())} URL ${headers.method} -> ${finalUrl} : ${time}ms`);
      }

      if (!response.ok) {
        throw { ...data, message: data.message || ERROR_MSG };
      }

      return data;
    } catch (err) {
      if (!isProduction || isServer) {
        console.log(err);
      }

      throw err;
    }
  }

  const methods = {
    get: (params = {}) => {
      const {
        overrideHeaders = {},
        queryParams = {},
        token = null,
        throwError = false,
        timeout = process.env.NEXT_PUBLIC_TIMEOUT_FETCH,
      } = params;

      return executeRequest(queryParams, createHeaders(token, null, overrideHeaders), throwError, timeout);
    },

    put: (params = {}) => {
      const {
        queryParams = {},
        body = null,
        token = null,
        throwError = false,
        timeout = process.env.NEXT_PUBLIC_TIMEOUT_FETCH,
      } = params;

      const createdOptions = { ...createHeaders(token, 'PUT'), method: 'PUT' };

      if (body) {
        createdOptions.body = JSON.stringify(body);
      }

      return executeRequest(queryParams, createdOptions, throwError, timeout);
    },

    post: (params = {}) => {
      const {
        queryParams = {},
        body = null,
        token = null,
        throwError = false,
        headers = {},
        timeout = process.env.NEXT_PUBLIC_TIMEOUT_FETCH,
      } = params;
      const createdOptions = { ...createHeaders(token, 'POST', headers), method: 'POST' };

      if (body) {
        createdOptions.body = JSON.stringify(body);
      }

      return executeRequest(queryParams, createdOptions, throwError, timeout);
    },

    delete: (params = {}) => {
      const {
        queryParams = {},
        token = null,
        throwError = false,
        timeout = process.env.NEXT_PUBLIC_TIMEOUT_FETCH,
      } = params;

      return executeRequest(queryParams, { ...createHeaders(token, 'DELETE'), method: 'DELETE' }, throwError, timeout);
    },
  };

  return methods;
};

export default requestAPI;
